export default "__VITE_ASSET__$hrWFVjV__"